import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles(() =>
  createStyles({
    root: {
      paddingTop: 0,
    },
  }),
);
